class AuthenticationController {
  constructor (Localization, UserService, VehicleService, RegistrationService, MetricsService,
               $window, $state, $location, $stateParams, $rootScope, I18n, vcRecaptchaService, CookiesService)
  {
    'ngInject'

    // Set injections
    this.userService = UserService
    this.vehicleService = VehicleService
    this.registrationService = RegistrationService
    this.metricsService = MetricsService
    this.$state = $state
    this.$stateParams = $stateParams
    this.$location = $location
    this.$window = $window
    this.country = Localization.getCountry().toUpperCase()
    this.I18n = I18n
    this.cookiesService = CookiesService
    this.vcRecaptchaService = this.captchaConsent ? vcRecaptchaService : undefined
    $rootScope.$on('cookieConsentUpdated', () => {
      this.vcRecaptchaService = this.captchaConsent ? vcRecaptchaService : undefined
    })
    this.setWidgetId = function (widgetId) {
      this.widgetId = widgetId
    }
    this.passwordExpirationDay = Localization.getLocalizedAppConfig().passwordExpirationDay
    this.siteKey = Localization.getLocalizedAppConfig().googleRecaptchaClientKey

    // Init. proccessing value
    this.isProcessing = false

    // Reset password case
    if ($stateParams.email && $stateParams.token) {
      if ($stateParams.huType) {
        this.loaded = this.registrationConfirmation($stateParams.email, $stateParams.token, $stateParams.huType)
      } else {
        this.loaded = this.resetPasswordConfirmation($stateParams.email, $stateParams.token)
      }
    }
  }

  get lang () {
    if (typeof (this.widgetId) !== 'undefined' && this.vcRecaptchaService && this.vcRecaptchaService.useLang(this.widgetId) !== this.I18n.getLanguage()) {
      this.vcRecaptchaService.useLang(this.widgetId, this.I18n.getLanguage())
    }
    return this.I18n.getLanguage()
  }

  resetPasswordConfirmation (email, token) {
    this.isProcessing = true
    return this.userService.resetPasswordConfirmation(email, token)
    .then((success) => {
      this.success = success
      this.isProcessing = false
      return success
    }, (err) => {
      this.error = err
      this.isProcessing = false
      return err
    })
  }

  registrationConfirmation (email, token, huType) {
    this.isProcessing = true
    return this.registrationService.confirmRegistration({ email, token, huType })
    .then((success) => {
      this.success = success
      this.isProcessing = false
      return success
    }, (err) => {
      this.error = err
      this.isProcessing = false
      return err
    })
  }

  // Function to call on submit
  login (form) {
    if (form.loginForm.$valid) {
      this.isProcessing = true
      this.metricsService.startPageLoadTime()
      return this.userService.login(this.credentials)
      .then((success) => {
        this.isProcessing = false
        if (this.userService.isPasswordExpired(success.customer.lastPasswordUpdate, this.passwordExpirationDay)) {
          // Redirect to the change password page
          return this.$state.go('changePassword')
        } else {
          // Redirect to the catalog page
          return this.vehicleService.getCurrentSelectedVehicle()
            .then((vehicle) => {
              if (vehicle) {
                return this.$state.go('vehicle', {vin: vehicle.vin, sync: false})
              }
              return this.$state.go('profile.myGarage')
            })
        }
      }, (err) => {
        this.error = err
        this.isProcessing = false
        return this.metricsService.endPageLoadTime(500)
      })
    }
  }

  formInvalid (form) {
    if (this.userService.getCaptchaNeeded()) {
      if (!this.captchaConsent) {
        return true
      }
    }
    return form.loginForm.$invalid
  }

  get captchaConsent () {
    return this.cookiesService.consentForCookie('captcha')
  }

}

export default AuthenticationController



// WEBPACK FOOTER //
// ./src/app/pages/authentication/authentication.controller.js